// eslint-disable-next-line import/prefer-default-export
export const API_USER_FEEDBACK = '/user-feedback/add';
